<template>
    <div>
        <p v-if="!lineItems.length" class="text-center mt-5">No order items found.</p>

        <div v-for="item in lineItems" :key="item.id" class="card general-card item-card">
            <div class="item-card-header">
                <div class="row align-items-center">
                    <div class="col-md-4 col-12">
                        <p class="mb-25 item-title">{{ item.product_name }}</p>
                        <p class="mb-0" style="font-size: 12px; color: #6c757d">PI Qty: {{ item.quantity }}</p>
                    </div>
                    <div class="col-md-4 col-12">
                        <p class="mb-25">
                            Delivered: {{ deliveredQty(item) }} of {{ item.quantity }}
                            <span style="color: #6c757d">(Remaining: {{ remainingQty(item) }})</span>
                        </p>
                        <div class="progress-track">
                            <div class="progress-fill" :style="{ width: progressWidth(deliveredQty(item), item.quantity) }"></div>
                        </div>
                    </div>
                    <div class="col-md-4 col-12 d-flex justify-content-between align-items-center">
                        <a href="javascript:void(0)" class="fw-bold" @click="onCreateNew(item, 'challan')">+ Add Challan</a>
                    </div>
                </div>
            </div>

            <div class="px-1 pb-1">
                <p v-if="!recordsOf(item).length" class="text-center my-2">No delivery challans for this item yet.</p>

                <div v-for="record in recordsOf(item)" :key="record.general.id" class="challan-record-row">
                    <div class="line-tier">
                        <div class="row align-items-center">
                            <div class="col-md-2 col-6">
                                <p class="mb-0 fw-bold">{{ record.challan.challan_number }}</p>
                                <p class="mb-0" style="font-size: 12px; color: #6c757d">{{ readableDate(record.challan.challan_date) }}</p>
                            </div>
                            <div class="col-md-3 col-6">
                                <p class="mb-0" style="font-size: 12px; color: #6c757d">Customer / Location</p>
                                <p class="mb-0">{{ record.challan.contact_name }} / {{ record.challan.business_location_name }}</p>
                            </div>
                            <div class="col-md-2 col-6">
                                <p class="mb-0" style="font-size: 12px; color: #6c757d">Qty / Rate</p>
                                <p class="mb-0">{{ record.general.quantity }} / {{ commaFormat(record.general.rate) }}</p>
                            </div>
                            <div class="col-md-2 col-6">
                                <p class="mb-0" style="font-size: 12px; color: #6c757d">VAT / Amount</p>
                                <p class="mb-0">{{ commaFormat(record.general.vat_amount) }} / {{ commaFormat(record.general.total_amount) }}</p>
                            </div>
                            <div v-if="record.general.description" class="col-md-3 col-6">
                                <p class="mb-0" style="font-size: 12px; color: #6c757d">Line Note</p>
                                <p class="mb-0">{{ record.general.description }}</p>
                            </div>
                        </div>

                    </div>

                    <div class="challan-tier">
                        <div class="row align-items-center">
                            <div class="col-md-2 col-6">
                                <p class="mb-0" style="font-size: 11px; color: #9aa1ab">Challan Subtotal</p>
                                <p class="mb-0">{{ commaFormat(record.challan.subtotal_amount) }}</p>
                            </div>
                            <div class="col-md-2 col-6">
                                <p class="mb-0" style="font-size: 11px; color: #9aa1ab">Challan VAT</p>
                                <p class="mb-0">{{ commaFormat(record.challan.vat_amount) }}</p>
                            </div>
                            <div class="col-md-2 col-6">
                                <p class="mb-0" style="font-size: 11px; color: #9aa1ab">Challan Total</p>
                                <p class="mb-0">{{ commaFormat(record.challan.total_amount) }}</p>
                            </div>
                            <div class="col-md-2 col-6">
                                <p class="mb-0" style="font-size: 11px; color: #9aa1ab">Paid</p>
                                <p class="mb-0">{{ commaFormat(record.challan.paid_amount) }}</p>
                            </div>
                            <div class="col-md-4 col-12 d-flex justify-content-md-end align-items-center gap-1">
                                <a href="javascript:void(0)" class="fw-bold" @click="onClickPrint(record.challan)"><i class="fas fa-print"></i></a>
                                <a href="javascript:void(0)" class="fw-bold" @click="onEditChallan(record.challan)">Edit</a>
                            </div>
                        </div>
                        <div v-if="record.challan.description" class="row align-items-center mt-25">
                            <div class="col-12">
                                <p class="mb-0" style="font-size: 11px; color: #9aa1ab">Challan Memo</p>
                                <p class="mb-0">{{ record.challan.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="unlinkedRows.length" class="card general-card">
            <div class="px-1 pb-1 pt-1">
                <p class="mb-25 fw-bold">Other Delivery Challan Lines</p>
                <div class="table-responsive">
                    <table class="table custom-table-padding">
                        <thead>
                            <tr>
                                <th>Challan No</th>
                                <th>Product</th>
                                <th class="text-right">Quantity</th>
                                <th class="text-right">Rate</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in unlinkedRows" :key="row.general.id">
                                <td>{{ row.challan.challan_number }}</td>
                                <td>{{ row.general.product_name }}</td>
                                <td class="text-right">{{ row.general.quantity }}</td>
                                <td class="text-right">{{ commaFormat(row.general.rate) }}</td>
                                <td class="text-right">{{ commaFormat(row.general.amount) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <Loader v-if="printing"/>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import figureFormatter from '@/services/utils/figureFormatter'
import useDate from '@/services/utils/day'
import handlePurchase from '@/services/modules/purchase'
import handleBarcode from '@/services/modules/barcode'
import handleCompany from '@/services/modules/company'
import POChallanPdfPrinter from '@/services/utils/POChallanPdfPrinter'
import Loader from '@/components/atom/LoaderComponent'

const props = defineProps({
    orderDetail: { type: Object, required: true },
    onCreateNew: { type: Function, required: true },
    onEditChallan: { type: Function, required: true }
})

const route = useRoute()
const store = useStore()
const { commaFormat } = figureFormatter()
const { formatToDdMmYy, formatDateTime } = useDate()
const { fetchDeliveryChallan } = handlePurchase()
const { fetchBarcode } = handleBarcode()
const { fetchCompanyInfo, fetchActiveCustomizationField } = handleCompany()
const { exportToPDF: exportChallanPDF } = POChallanPdfPrinter()

const printing = ref(false)
const companyInfo = ref({})
const customizationPdfFields = ref([])

const lineItems = computed(() => {
    if (!props.orderDetail.order_summary) return []
    if (!props.orderDetail.order_summary.line_items) return []
    return props.orderDetail.order_summary.line_items
})

const challanList = computed(() => {
    if (!props.orderDetail.delivery_challan) return []
    return props.orderDetail.delivery_challan
})

const generalsOf = (challan) => {
    if (!challan.general) return []
    return challan.general
}

const recordsByLineItemId = computed(() => {
    const map = {}
    challanList.value.forEach((challan) => {
        generalsOf(challan).forEach((general) => {
            if (!general.sales_order_general_id) return
            if (!map[general.sales_order_general_id]) map[general.sales_order_general_id] = []
            map[general.sales_order_general_id].push({ general, challan })
        })
    })
    return map
})

const recordsOf = (item) => {
    if (!recordsByLineItemId.value[item.id]) return []
    return recordsByLineItemId.value[item.id]
}

const deliveredQty = (item) => {
    if (!item.total_del_qty) return 0
    return item.total_del_qty
}

const remainingQty = (item) => {
    const remaining = Number(item.quantity || 0) - Number(deliveredQty(item))
    if (remaining < 0) return 0
    return remaining
}

const unlinkedRows = computed(() => {
    const rows = []
    challanList.value.forEach((challan) => {
        generalsOf(challan).forEach((general) => {
            if (general.sales_order_general_id) return
            rows.push({ general, challan })
        })
    })
    return rows
})

const readableDate = (date) => {
    if (!date) return ''
    return formatToDdMmYy(String(date).split(' ')[0])
}

const progressWidth = (done, target) => {
    if (!target) return '0%'
    const ratio = (Number(done) / Number(target)) * 100
    if (ratio > 100) return '100%'
    return `${ratio.toFixed(0)}%`
}

const companyQuery = () => {
    return `?company_id=${route.params.companyId}`
}

const buildQrCodeQuery = (billNumber, refDate, userName) => {
    const qrcodeData = JSON.stringify({
        ref_no: billNumber,
        ref_date: refDate,
        created_by: userName,
        created_date_time: formatDateTime(new Date())
    })
    return `?code=${billNumber}&qrcode=${qrcodeData}`
}

const loadCompanyInfo = async () => {
    if (companyInfo.value.id) return
    await fetchCompanyInfo(route.params.companyId).then((res) => {
        companyInfo.value = res.data
    })
}

const loadCustomizationFields = async () => {
    const query = companyQuery() + '&customization_type=pdf&type=delivery_challan_pdf'
    await fetchActiveCustomizationField(query).then((res) => {
        customizationPdfFields.value = res.data
    })
}

const onClickPrint = async (challan) => {
    if (!challan.id) return
    const user = store.state.user.user
    printing.value = true
    await loadCompanyInfo()
    await loadCustomizationFields()

    await fetchDeliveryChallan(challan.id, companyQuery()).then(async (res) => {
        if (!res) return
        const product = res.data
        const barcodeQuery = buildQrCodeQuery(product.challan_number, product.challan_date, user.name)
        await fetchBarcode(barcodeQuery).then((res) => {
            exportChallanPDF(companyInfo.value, product, res.barcode, res.qrcode, user.name, 1, customizationPdfFields.value)
        })
    })

    printing.value = false
}
</script>

<style scoped>
.general-card {
    min-height: auto;
}
.item-card {
    overflow: hidden;
}
.item-card-header {
    padding: 0.85rem 1rem;
    background-color: rgba(115, 103, 240, 0.06);
    border-bottom: 1px solid rgba(115, 103, 240, 0.14);
}
.item-title {
    font-size: 15px;
    font-weight: 600;
}
.challan-record-row {
    border-bottom: 1px solid #eef0f5;
}
.challan-record-row:last-child {
    border-bottom: none;
}
.line-tier {
    padding: 0.6rem 0.5rem 0.5rem;
}
.challan-tier {
    padding: 0.5rem 0.5rem 0.6rem;
    margin: 0 0.5rem 0.5rem;
    background-color: #fafbfc;
    border-radius: 6px;
    border: 1px dashed #e5e7eb;
}
.fw-bold {
    font-weight: bold !important;
}
.progress-track {
    width: 100%;
    max-width: 240px;
    height: 6px;
    border-radius: 3px;
    background-color: #e5e7eb;
}
.progress-fill {
    height: 100%;
    border-radius: 3px;
    background-color: #22c55e;
}
</style>
